import Chatarea from "../Pages/ChatArea";
import {  CHATAREA, COMEFUNZIONA, CONTATTI } from "./constURL";
import Contact from "../Pages/Contact";
import Howitworks from "../Pages/Howitworks";
export const globalRoutes = [
  {
    path: CHATAREA,
    element: Chatarea,
  },
  {
    path: COMEFUNZIONA,
    element: Howitworks,
  },
  {
    path: CONTATTI,
    element: Contact
  },
];
